const sRGBAssume = (spectrum) => {
  if (spectrum <= 0.04045) {
    return spectrum / 12.92;
  }
  return ((spectrum + 0.055) / 1.055) ** 2.4;
};

export default sRGBAssume;
